/** @module Enums */ /** typedoc */

export enum PaymentCycleEnum {
    Monthly = 'Monthly',
    Yearly = 'Yearly'
}
